module.exports = "<p>detailspopups works!</p>\n"